import { actions, reducer } from './redux';
export const { addNotify } = actions;
export { actions, reducer };